<template lang="html">
	<div class="chats">
		<!-- <div class="title-content">
         <div class="title">My Chats</div>
      </div> -->
		<div class="row">
			<div class="col-12 col-md-5 col-xl-4">
				<div class="scroll-content">
					<scrollbar>
						<ChatUser
							v-for="(user, i) in conversations"
							:key="i"
							:user="user"
							@click.native="changeSelectedConversation(user)"
						/>
					</scrollbar>
				</div>
			</div>
			<div class="col-12 col-md-7 col-xl-8">
				<div class="message-box">
					<div class="title-box clearfix" v-if="selectedConversation">
						<img
							:src="activeUser.profile"
							alt=""
							class="icon-box f-l"
						/>
						<div class="content-box f-l">
							<div class="top clearfix">
								<div class="title f-l">
									{{ selectedConversation.names }}
								</div>
							</div>
							<div
								class="bottom clearfix"
								v-show="activeUser.isOnline"
							>
								<div class="circle f-l"></div>
								<div class="txt f-l">Online</div>
							</div>
						</div>
					</div>
					<div class="scroll-message">
						<scrollbar id="message-scroll" ref="scrollbar">
							<div class="message-content">
								<div class="row">
									<div
										class="group clearfix"
										v-for="(group, i) in messages"
										:key="i"
									>
										<div class="col-12">
											<div class="date-pointer">
												<div class="text">
													{{ group.text }}
												</div>
											</div>
										</div>
										<div
											class="message col-11 col-sm-10"
											v-for="(
												message, j
											) in group.messages"
											:key="j"
											:class="{ owner: message.isOwner }"
										>
											<div class="msg-grouping">
												<div class="txt">
													{{ message.text }}
												</div>
												<div class="time">
													{{ message.time }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</scrollbar>
					</div>
					<div class="reply-box">
						<textarea
							class="form-control"
							rows="3"
							placeholder="Type your message…"
							:value="text"
							@input="updateText($event.target.value)"
						>
						</textarea>
						<div class="action-row clearfix">
							<div class="f-l icon-btns">
								<i class="fa fa-paperclip"></i>
								<i class="fa fa-plus-circle"></i>
							</div>
							<div
								class="f-r send-btn"
								@click="sendMessage({ text })"
							>
								<i class="fa fa-paper-plane"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import chat from '../rsc/stores/chat.store';
import VueScrollbar from 'vue-scrollbar-simple';

export default {
	beforeCreate() {
		Event.$emit('loader:show', true);
	},
	beforeDestroy() {
		this.destroyEvents();
		this.$store.unregisterModule('chat');
	},
	created() {
		utils.registerModule('chat', chat, this.$store);
	},
	computed: {
		// text: {
		//    get () {
		//       return this.$store.state.text
		//    },
		//    set (value) {
		//       this.$store.commit('text', value)
		//    }
		// },
		...mapGetters([
			'loading',
			'text',
			'conversations',
			'selectedConversation',
			'messages',
		]),
	},
	components: {
		scrollbar: VueScrollbar,
		ChatUser: () => import('../templates/others/chat-user'),
		Message: () => import('../templates/others/message'),
	},
	data() {
		return {
			activeUser: {
				name: 'Brian Mbunde',
				isOnline: true,
				profile: '/img/avatars/2.png',
			},
			groups: [],
		};
	},
	methods: {
		...mapActions([
			'destroyEvents',
			'fetchConversations',
			'sendMessage',
			'changeSelectedConversation',
			'listenForMessage',
		]),
		...mapMutations({
			updateText: 'text',
		}),
	},
	async mounted() {
		utils.registerModule('chat', chat, this.$store);
		this.$store.commit('message_scroll', this.$refs.scrollbar);
		await this.fetchConversations();
		await this.listenForMessage();
		Event.$emit('loader:show', false);
	},
};
</script>

<style lang="less">
.chats {
	.scroll-content {
		height: calc(100vh - 130px);
	}
	.scroll-message {
		height: calc(100vh - 450px);
	}
	.group {
		width: 100%;
	}
	.message-content {
		padding: 0 25px 20px 25px !important;

		.message {
			margin: 10px 0;
			// width: 70%;
			display: inline-block;

			.txt {
				border-radius: 4px;
				border: solid 1px #e9edf0;
				padding: 20px 15px;
				font-size: 13px;
				font-weight: 600;
			}
			.time {
				font-size: 12px;
				font-weight: 600;
				display: inline-block;
				color: var(--text-grey);
			}
		}
		.message.owner {
			float: right;

			.txt {
				background: #f1f3f6;
			}
		}
		.date-pointer {
			border-bottom: solid 1px #e9edf0;
			display: flex;
			justify-content: center;
			position: relative;
			margin: 30px 0;

			.text {
				margin: -20px 0 0 0;
				padding: 7px 25px;
				color: var(--ne-blue);
				font-size: 14px;
				font-weight: 600;
				position: absolute;
				background: var(--white);
			}
		}
	}
	.reply-box {
		margin: 40px 25px;
		border-radius: 4px;
		box-shadow: 0 2px 4px 0 #0000000a;
		border: solid 1px #e9edf0;
		cursor: pointer;

		.action-row {
			padding: 10px 15px;

			.send-btn {
				width: 40px;
				height: 40px;
				padding: 8px 0 0 0;
				font-size: 18px;
				text-align: center;
				background: var(--ne-yellow);
				color: var(--white);
				border-radius: 50%;

				&:hover {
					background: darken(#fcb23b, 20%);
				}
			}
			.icon-btns {
				i {
					font-size: 20px;
					cursor: pointer;
					position: relative;
					margin: 0 8px;
					opacity: 0.35;
					color: #344563;
				}
				i:hover {
					opacity: 1;
				}
			}
		}
		textarea {
			border: 0;
		}
	}
	.message-box {
		background: var(--white);
		border: solid 1px #e6eaee;
		border-radius: 4px;

		.title-box {
			border-bottom: solid 1px #e6eaee;
			padding: 15px 20px;

			.content-box {
				width: calc(100% - 65px);

				.circle {
					width: 7px;
					height: 7px;
					margin: 6px 8px 0 0;
					border-radius: 50%;
					background: var(--ne-green);
				}
				.title {
					color: #3d4661;
					font-weight: 600;
					font-size: 16px;
				}
				.txt {
					color: #646f79;
					font-size: 14px;
				}
			}
			.icon-box {
				width: 50px;
				height: 50px;
				border-radius: 50%;
				text-align: center;
				background: #3d4661;
				color: var(--white);
				margin: 0 15px 0 0;

				i {
					font-size: 24px;
					padding: 12px 0;
				}
			}
		}
		.message-content {
			padding: 25px 15px;
		}
	}
}
</style>
